import { render, staticRenderFns } from "./softwareInstalled.vue?vue&type=template&id=172d5990&"
import script from "./softwareInstalled.vue?vue&type=script&lang=js&"
export * from "./softwareInstalled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports